import React, { useEffect, useState } from 'react';
import { useFloorContext } from '../../context/FloorContext';
import { useNFTContext } from '../../context/NFTContext';
import { RoomObjectType } from '../../types/room';

import { useWindowSize } from '@uidotdev/usehooks';

const FloorSelectorTopFloor = () => {
  return (
    <>
      <div className="floor top-floor">
        <div className="face top"></div>
        <div className="face left"></div>
        <div className="face right"></div>
      </div>
      <div className="floor pin">
        <div className="face top"></div>
        <div className="face left"></div>
        <div className="face right"></div>
      </div>
    </>
  );
};

const FloorCube = ({
  onClick,
  selected = false,
  isLoading,
  floorNumber,
  filteredNFTs,
}: {
  onClick: () => void;
  selected?: boolean;
  isLoading: boolean;
  floorNumber: number;
  filteredNFTs: RoomObjectType[];
}) => {
  const { currentFloor } = useFloorContext();
  const [searchResultsAmount, setSearchResultsAmount] = useState(0);

  useEffect(() => {
    const amount = filteredNFTs.filter(
      (nft) => nft.roomFloor === floorNumber
    ).length;

    if (amount > 0) {
      setSearchResultsAmount(amount);
    } else {
      setSearchResultsAmount(0);
    }
  }, [filteredNFTs, floorNumber]);

  return (
    <div
      className={`floor ${selected ? 'selected' : ''} ${
        searchResultsAmount > 0 ? 'highlighted' : ''
      } ${floorNumber}`}
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      <div className="face top"></div>
      <div className="face left"></div>
      <div className="face right"></div>
      <div className="number">{floorNumber}</div>
      {currentFloor !== floorNumber &&
        searchResultsAmount > 0 &&
        !isLoading && (
          <div className="floor-search-results">{searchResultsAmount}</div>
        )}
    </div>
  );
};

const FloorSelector = ({
  showLandingPage,
  handleFloorChange,
}: {
  showLandingPage: boolean;
  handleFloorChange: (index: number) => void;
}) => {
  const { filteredNFTs } = useNFTContext();
  const { totalFloors, currentFloor } = useFloorContext();
  const [isChangingFloor, setIsChangingFloor] = useState(false);
  const screenSize = useWindowSize();
  const screenHeight = screenSize.height ?? 3000;

  useEffect(() => {
    // floors or search resuts updated
    setIsChangingFloor(false);
  }, [currentFloor, totalFloors, filteredNFTs]);

  return (
    <>
      {!showLandingPage && (
        <div className="floor-selector-current-floor-caption-container ">
          <div className="floor-selector-current-floor-type">Genesis Hotel</div>
          <div className="floor-selector-current-floor">
            Floor {currentFloor}
          </div>
        </div>
      )}
      <div
        className="floor-selector-container"
        style={{
          transform: `scale(${screenHeight / 3000})`,
        }}
      >
        {[...Array(totalFloors)].map((value: undefined, index: number) => (
          <FloorCube
            key={`floor-selector-${index + 1}`}
            filteredNFTs={filteredNFTs}
            selected={currentFloor === index + 1}
            floorNumber={index + 1}
            isLoading={isChangingFloor}
            onClick={() => {
              setIsChangingFloor(true);
              handleFloorChange(index + 1);
            }}
          />
        ))}
        <FloorSelectorTopFloor />
      </div>
    </>
  );
};

export default FloorSelector;
